import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, ArrowUpRight, MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/site";

export default function FloatingContact() {
    const [open, setOpen] = useState(false);

    return (
        <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3 md:bottom-8 md:right-8">
            <AnimatePresence>
                {open && (
                    <>
                        <motion.a
                            key="whatsapp"
                            href="https://wa.me/919035303716?text=Hi%20UMA%20ENGINEERING%2C%20I%20have%20an%20enquiry%20about%20your%20lifting%20systems."
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="floating-whatsapp-btn"
                            initial={{ opacity: 0, y: 16, scale: 0.9 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, y: 16, scale: 0.9 }}
                            transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
                            className="flex items-center gap-3 border border-[#25D366]/40 bg-deck/95 py-3 pl-4 pr-5 shadow-2xl backdrop-blur-md transition-colors hover:border-[#25D366]"
                        >
                            <MessageCircle className="h-4 w-4 text-[#25D366]" />
                            <span className="font-mono text-sm text-white">WhatsApp</span>
                        </motion.a>
                        <motion.a
                            key="call"
                            href={CONTACT.phones[0].href}
                            data-testid="floating-call-btn"
                            initial={{ opacity: 0, y: 16, scale: 0.9 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, y: 16, scale: 0.9 }}
                            transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
                            className="flex items-center gap-3 border border-line bg-deck/95 py-3 pl-4 pr-5 shadow-2xl backdrop-blur-md"
                        >
                            <Phone className="h-4 w-4 text-accent" />
                            <span className="font-mono text-sm text-white">
                                {CONTACT.phones[0].display}
                            </span>
                        </motion.a>
                        <motion.div
                            key="enquire"
                            initial={{ opacity: 0, y: 16, scale: 0.9 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, y: 16, scale: 0.9 }}
                            transition={{ duration: 0.25, delay: 0.05, ease: [0.16, 1, 0.3, 1] }}
                        >
                            <Link
                                to="/contact"
                                data-testid="floating-enquire-btn"
                                className="flex items-center gap-3 bg-accent py-3 pl-4 pr-5 font-display text-sm font-bold uppercase tracking-widest text-night shadow-2xl"
                            >
                                Enquire Now
                                <ArrowUpRight className="h-4 w-4" />
                            </Link>
                        </motion.div>
                    </>
                )}
            </AnimatePresence>
            <button
                data-testid="floating-contact-btn"
                onClick={() => setOpen(!open)}
                aria-label="Contact options"
                className="relative flex h-14 w-14 items-center justify-center rounded-full bg-accent text-night shadow-[0_8px_30px_rgba(255,107,0,0.35)] transition-transform duration-300 hover:scale-105 active:scale-95"
            >
                {!open && (
                    <span className="absolute inset-0 animate-ping rounded-full bg-accent/40" aria-hidden="true" />
                )}
                <Phone className={`h-6 w-6 transition-transform duration-300 ${open ? "rotate-45" : ""}`} />
            </button>
        </div>
    );
}
